import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@ezhire/types';

/**
 * Module-facing Supabase client accessor. Modules should pass the host's
 * client via a provider, but for simplicity in Phase 1 we fetch it from
 * the global that apps/web registers.
 */
declare global {
  interface Window {
    __ATLAS_SUPABASE__?: SupabaseClient<Database>;
  }
}

export function useSupabaseClient(options: { optional: true }): SupabaseClient<Database> | null;
export function useSupabaseClient(): SupabaseClient<Database>;
export function useSupabaseClient(options?: { optional: true }): SupabaseClient<Database> | null {
  const client = typeof window !== 'undefined' ? window.__ATLAS_SUPABASE__ : undefined;
  if (!client && options?.optional) return null;
  if (!client) {
    throw new Error(
      'Supabase client not registered. Apps must set window.__ATLAS_SUPABASE__ before rendering modules.',
    );
  }
  return client;
}
